import { render, staticRenderFns } from "./JournalInventoryView.vue?vue&type=template&id=91918690"
import script from "./JournalInventoryView.vue?vue&type=script&lang=js"
export * from "./JournalInventoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports